import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEyeSlash = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M15.1803 9.46992L10.1203 14.5299C9.47031 13.8799 9.07031 12.9899 9.07031 11.9999C9.07031 10.0199 10.6703 8.41992 12.6503 8.41992C13.6403 8.41992 14.5303 8.81992 15.1803 9.46992Z",
			stroke: "#2A2B2F",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.4702 5.76998C16.7202 4.44998 14.7202 3.72998 12.6502 3.72998C9.12023 3.72998 5.83023 5.80998 3.54023 9.40998C2.64023 10.82 2.64023 13.19 3.54023 14.6C4.33023 15.84 5.25023 16.91 6.25023 17.77",
			stroke: "#2A2B2F",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.07031 19.5302C10.2103 20.0102 11.4203 20.2702 12.6503 20.2702C16.1803 20.2702 19.4703 18.1902 21.7603 14.5902C22.6603 13.1802 22.6603 10.8102 21.7603 9.40018C21.4303 8.88018 21.0703 8.39018 20.7003 7.93018",
			stroke: "#2A2B2F",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.1598 12.7002C15.8998 14.1102 14.7498 15.2602 13.3398 15.5202",
			stroke: "#2A2B2F",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.1204 14.5298L2.65039 21.9998",
			stroke: "#2A2B2F",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.6497 2L15.1797 9.47",
			stroke: "#2A2B2F",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export { SvgEyeSlash as ReactComponent };
